module.exports = __webpack_public_path__ + "img/20.811a9a3d.jpg";